import { useSetPageTitle } from "@services/HeaderContext";
import AuthHeader from "@ui-components/layout/AuthHeader";
import PoweredBy from "@ui-components/layout/PoweredBy";

const TermsAndConditionsPage = () => {

    useSetPageTitle("Terms & Conditions");

    return (
        <div className="bg-am-400 min-h-full flex flex-col justify-center py-12 px-6 lg:px-8">
            <AuthHeader />
            <div className="mt-8 mx-auto w-full">
                <div className="bg-white shadow-md rounded-lg p-6 mt-6 max-w-4xl mx-auto">
                    <h1 className="text-3xl font-bold text-center">Terms & Conditions</h1>
                    <br />
                    <p><strong>Last Updated: </strong>5 February 2025</p>
                    <br />
                    <p>Welcome to AIAct Toolkit. By registering and using our platform (https://aiact.cloud.ammagamma.com/), you agree to comply with the following Terms and Conditions. Please read them carefully before proceeding with registration.</p>

                    <h2 className="text-2xl font-bold mt-4">1. Account Registration and Use</h2>
                    <ul className="list-[lower-alpha] list-inside">
                        <li>By creating an account, you confirm that you are providing accurate and complete information.</li>
                        <li>Your account is personal and should not be shared with others.</li>
                        <li>We reserve the right to suspend or terminate accounts that violate these Terms and Conditions.</li>
                    </ul>

                    <h2 className="text-2xl font-bold mt-4">2. Use of Email</h2>
                    <ul className="list-[lower-alpha] list-inside">
                        <li>Your email address is used solely for registration and account-related communications.</li>
                        <li>We do not use your email for marketing or any other purposes outside the scope of platform functionality.</li>
                    </ul>

                    <h2 className="text-2xl font-bold mt-4">3. Data Privacy and Access</h2>
                    <ul className="list-[lower-alpha] list-inside">
                        <li>All data entered into the project sections of AIAct Toolkit are accessible only to the project author and explicitly added collaborators.</li>
                        <li>We do not access, share, or distribute your project data unless required by law.</li>
                        <li>Upon deletion of a project, all associated data will be permanently removed and cannot be recovered.</li>
                    </ul>

                    <h2 className="text-2xl font-bold mt-4">4. User Responsibilities</h2>
                    <ul className="list-[lower-alpha] list-inside">
                        <li>Users are responsible for the accuracy and security of the data they input.</li>
                        <li>Unauthorized access to other users' projects or misuse of the platform is strictly prohibited.</li>
                    </ul>

                    <h2 className="text-2xl font-bold mt-4">5. Changes to Terms</h2>
                    <ul className="list-[lower-alpha] list-inside">
                        <li>AIAct Toolkit reserves the right to update these Terms and Conditions at any time.</li>
                        <li>Continued use of the platform after updates constitutes acceptance of the revised terms.</li>
                    </ul>

                    {/* <h2 className="text-2xl font-bold mt-4">6. Contact</h2>
                    <p>If you have any questions or concerns about these Terms and Conditions, please contact us at [Insert Contact Information].</p> */}
                </div>
            </div>
            <PoweredBy />
        </div>
    );
};

export default TermsAndConditionsPage;

